
import { productImageStyle, productInfoStyle, productItemStyle, productNameStyle, productPriceStyle } from "./CouponStyles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { CartItem } from "@ecommerce/store";
import { numberFormatter } from "@ecommerce/shared-utils";
import {STYLES} from "../ShoppingCart/ShoppingCartStyles";

export const ProductItem: React.FC<{ item: CartItem }> = ({ item }) => (
  <Box sx={productItemStyle}>
    <Box sx={{productInfoStyle}}>
      <Box component="img" src={item.image} alt={item.name} sx={productImageStyle} />
      <Typography sx={productNameStyle}>
        {item.name} - {item.quantity}
      </Typography>
        {item.attributes && item.attributes.length > 0 && (
            <Typography
                sx={{
                    fontFamily: STYLES.fontFamily,
                    fontSize: "12px",
                    color: "#666",
                    mb: 1,
                    textTransform: 'capitalize'
                }}
            >
                ({item.attributes.map(a => a.value).join(", ")})
            </Typography>
        )}
    </Box>
    <Typography sx={productPriceStyle}>
      {numberFormatter.toStringWithAmount((item.price * item.quantity), '$')}
    </Typography>
  </Box>
);














